import {
  AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_BEGIN,
  AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_SUCCESS,
  AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_FAILURE,
  AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function generateHtmlForPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_BEGIN,
    });
    
    const { version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-html-pages`,
        args,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGenerateHtmlForPagesError() {
  return {
    type: AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_BEGIN:
      return {
        ...state,
        generateHtmlForPagesPending: true,
        generateHtmlForPagesError: null,
      };

    case AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_SUCCESS:
      return {
        ...state,
        generateHtmlForPagesPending: false,
        generateHtmlForPagesError: null,
      };

    case AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_FAILURE:
      return {
        ...state,
        generateHtmlForPagesPending: false,
        generateHtmlForPagesError: action.data.error,
      };

    case AI_PROMPT_BUILDER_GENERATE_HTML_FOR_PAGES_DISMISS_ERROR:
      return {
        ...state,
        generateHtmlForPagesError: null,
      };

    default:
      return state;
  }
}
